import { render, staticRenderFns } from "./tableFleet.vue?vue&type=template&id=3fd3f653&"
import script from "./tableFleet.vue?vue&type=script&lang=js&"
export * from "./tableFleet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports